<script>
  import { getContext } from 'svelte';
  import ContentBox from '../ContentBox/ContentBox.svelte';
  import LoadProfileForm from './LoadProfileForm.svelte';
  import FixedContent from '../FixedContent/FixedContent.svelte';
  import Button from '../Button/Button.svelte';

  const state = getContext('state');

  let shareLink = `https://csgostats.info?nickname=${$state.data.playerData.nickname}`;

  const copyShareLink = () => {
    const copyText = document.getElementById('share-link');
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");

    if (!$state.disableEvents) {
      gtag('event', 'Copy Share Link', {
        'event_category': $state.nickname
      });
    }
  };
</script>

<FixedContent>
  <div class="mt-4  md:flex  justify-between  items-center">
    <ContentBox border={true}>
      <LoadProfileForm slim={true} />
    </ContentBox>

    {#if !$state.loading.playerData && $state.data.playerData && $state.data.playerStats && $state.data.playerData.player_id && $state.data.playerStats.player_id}
    <ContentBox>
      <div class="flex  items-center">
        <label class="mr-2  text-gray-700">Share Link:</label>
        <input type="text" id="share-link" bind:value={shareLink} class="text-black  focus:outline-none  rounded-r-none" />
        <Button text="Copy" inline={true} onClick={copyShareLink} />
      </div>
    </ContentBox>
    {/if}
  </div>
</FixedContent>
